import styled from "styled-components";
import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  margin: 5rem auto;

  ${Container}
`;

export const Content = styled.div`
  width: 100%;
  padding: 1rem 0;
  h1 {
    font-size: 72px;
  }
  Button {
    margin-right: 1rem;
    padding: 0.5rem 1rem;
  }
  .stack{
    font-size: 14px;
  font-weight: 300;
  }
  .justified{
    text-align: justify;
  }
`;
